// @mui
import {
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
// components
import Layout from '~/layouts'
import PreviewForm from 'domains/Users/Verification/containers/PreviewForm'
import Page from 'components/Page'
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs'
// constants
import { TERMS_CONDITION_URL } from '~/config'
import { PATH_DASHBOARD } from 'routes/paths'
// hooks
import useSettings from 'hooks/useSettings'
import useAuth from 'hooks/useAuth'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import useLocales from 'hooks/useLocales'

const FillProfileDialog = dynamic(
  () => import('commons/containers/FillProfileDialog'),
)

export default function VerifiedPage() {
  const { t } = useLocales()
  const { query } = useRouter()
  const { themeStretch } = useSettings()
  const { user, doUserAuthenticated } = useAuth()

  const pageShowCreatorForm = [
    '/event/create',
    '/dashboard/create-content',
  ]

  const [isOpenFillProfileDialog, setIsOpenFillProfileDialog] =
    useState(false)

  useEffect(() => {
    if (
      user?.creator?.creator_class === 'PERSONAL' &&
      pageShowCreatorForm.includes(query?.source?.toString())
    ) {
      setIsOpenFillProfileDialog(true)
    }
  }, [user])

  return (
    <Layout>
      <Page title={t('key_data_verification_input')}>
        <Container maxWidth={themeStretch ? false : 'xl'}>
          <HeaderBreadcrumbs
            heading={t('key_data_verification_input')}
            links={[
              { name: 'Dashboard', href: PATH_DASHBOARD.root },
              {
                name: t('key_data_verification'),
                href: PATH_DASHBOARD.general.verification.root,
              },

              {
                name: t('key_data_verification_input'),
              },
            ]}
          />
          <Stack
            sx={(theme) => ({
              [theme.breakpoints.up('md')]: {
                maxWidth: '720px',
              },
              margin: '0px auto',
              gap: '24px',
            })}
          >
            <PreviewForm
              title={t('key_verify_your_data')}
              subtitle={t(
                'key_we_have_successfully_verified_your_data',
              )}
              badge={
                <Stack
                  direction="row"
                  sx={(theme) => ({
                    borderRadius: '6px',
                    padding: '1px 8px',
                    backgroundColor: theme.palette.success.dark,
                    gap: 0.5,
                    alignItems: 'center',
                  })}
                >
                  <Typography
                    variant="overline"
                    sx={(theme) => ({
                      color: theme.palette.common.white,
                      textTransform: 'none',
                    })}
                  >
                    {t('key_verified')}
                  </Typography>
                  <VerifiedUserIcon
                    sx={(theme) => ({
                      fontSize: '14px',
                      color: theme.palette.common.white,
                    })}
                  />
                </Stack>
              }
              // headerEndAdornment={
              //   <Button
              //     variant="outlined"
              //     onClick={() => {
              //       setActiveStep(0)
              //       setEditingMode(true)
              //     }}
              //   >
              //     Ubah
              //   </Button>
              // }
              customFooter={
                <>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>

                  <Grid item xs={12} justifyContent="center">
                    <Typography variant="body2" textAlign="center">
                      {t('key_read')}{' '}
                      <Typography
                        id="l-users-verifiedpage-terms"
                        role="link"
                        variant="body2"
                        onClick={() => {
                          window.open(
                            `${TERMS_CONDITION_URL}#Aplikasi,-Akun-dan-Keamanan`,
                            '_blank',
                          )
                        }}
                        sx={(theme) => ({
                          color: theme.palette.info.main,
                          display: 'inline',
                          cursor: 'pointer',
                        })}
                      >
                        {t('key_terms_and_conditions')}
                      </Typography>{' '}
                      TipTip
                    </Typography>
                  </Grid>
                </>
              }
              showDefaultCTA={false}
              setActiveStepEditBank={undefined}
            />
          </Stack>

          <FillProfileDialog
            isOpen={isOpenFillProfileDialog}
            onClose={() => {
              setIsOpenFillProfileDialog(false)
            }}
            onSuccess={() => {
              doUserAuthenticated()
              setIsOpenFillProfileDialog(false)
            }}
          />
        </Container>
      </Page>
    </Layout>
  )
}
